import { createGlobalStyle } from 'styled-components';
export default createGlobalStyle([".ant-table-filter-dropdown-btns{align-items:center;}"]);